import { RouterProvider } from "react-router";

import { router } from "./router";

export const App = () => <RouterProvider router={router} />;
